import ToastMessageScaffold from './ToastMessageScaffold';

export default ToastMessageScaffold;
